import React from "react"
import { getBreadcrumbComponent } from "./utils"

export const ArticleBreadcrumbs = ({ breadcrumb_array }) => {
  return (
    <div
      x-bi-data-nosnippet="true"
      style={{
        display: "flex",
        borderBottom: "1px solid #EEE",
      }}
      className="pb-2"
    >
      <nav className="level is-mobile" aria-label="breadcrumbs">
        <div className="level-left page-breadcrumbs no-scrollbar">
          {breadcrumb_array.map(getBreadcrumbComponent)}
        </div>
      </nav>
    </div>
  )
}
